// src/pages/TeamManagementPage.js
import React, { useState, useEffect } from "react";
import { Layout } from "../components/Layout";
import Breadcrumb from "../components/Breadcrumb";
import { getUsers, createUser, updateUser } from "../services/userService";
import TeamTable from "../components/TeamTable";
import TeamForm from "../components/TeamForm";
import {
  AddButton,
  Container,
  Title,
  TableWrapper,
  HeaderRow
} from "../styles/StyledComponents";

const TeamManagementPage = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [newMember, setNewMember] = useState({
    name: "",
    email: "",
    telephone: "",
    employeeId: "",
    profile: "user",
    status: true,
    firstAccess: false
  });

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getUsers();
        setTeamMembers(data);
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
      }
    };

    fetchUsers();
  }, []);

  const handleInputChange = e => {
    const { name, value, type, checked } = e.target;
    setNewMember(prevState => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleFormSubmit = async e => {
    e.preventDefault();
    if (editingMember) {
      await updateUser(editingMember._id, newMember);
    } else {
      await createUser(newMember);
    }
    setFormVisible(false);
    setEditingMember(null);
    window.location.reload();
  };

  const handleEdit = member => {
    setEditingMember(member);
    setNewMember(member);
    setFormVisible(true);
  };

  const handleAddNew = () => {
    setEditingMember(null);
    setNewMember({
      name: "",
      email: "",
      password: "", // Adicionado campo de senha
      telephone: "",
      employeeId: "",
      profile: "Usuario",
      status: true,
      firstAccess: true // Definido como verdadeiro por padrão para novos usuários
    });
    setFormVisible(true);
  };

  return (
    <Layout pageTitle="Administração da Equipe">
      <Breadcrumb items={["Home", "Equipe", "Lista de usuários"]} />
      <Container>
        <TableWrapper>
          <HeaderRow>
            <Title>Cadastro geral de usuários.</Title>
            <AddButton onClick={handleAddNew}>+ Novo Membro</AddButton>
          </HeaderRow>
          <TeamTable teamMembers={teamMembers} onEdit={handleEdit} />
        </TableWrapper>
        <TeamForm
          visible={formVisible}
          member={newMember}
          onChange={handleInputChange}
          onSubmit={handleFormSubmit}
          onCancel={() => setFormVisible(false)}
          isEditing={!!editingMember}
        />
      </Container>
    </Layout>
  );
};

export default TeamManagementPage;
